module.exports = __webpack_public_path__ + "img/walkie-talkie.c149c818.svg";